import { useRef, useState, useEffect } from "react";
import useDetectOutsideClick from "../useDetectOutsideClick";
import { DefaultSliderIcon } from "../components/Icons";

const useOpacity = ({ DEFAULT_OPACITY }) => {
  const [opacityBtnStatus, setOpacityBtnStatus] = useState(true);
  const [opacityLayerValue, setOpacityLayerValue] = useState(DEFAULT_OPACITY);
  return {
    opacityBtnStatus,
    opacityLayerValue,
    setOpacityBtnStatus,
    setOpacityLayerValue,
  };
};

const OpacitySlider = ({
  onChange,
  SliderIcon,
  btnStatus,
  defaultOpacity,
  tooltipFor,
}) => {
  const [sliderValue, setSliderValue] = useState();
  const opacitySliderRef = useRef();
  const sliderContainerRef = useRef();
  const [isActive, setIsActive] = useDetectOutsideClick(
    sliderContainerRef,
    false
  );

  const onRangerChange = () => {
    setSliderValue(Number(opacitySliderRef.current.value));
    onChange(Number(opacitySliderRef.current.value));
  };

  useEffect(() => {
    setSliderValue(defaultOpacity);
  }, [defaultOpacity]);

  return (
    <div className="opacity-slider">
      <button
          aria-label="open opacity slider"
        className={`bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-1 border border-gray-400 rounded shadow ${
          btnStatus ? `opacity-50 cursor-not-allowed` : ""
        }`}
        onClick={() => {
          if (!isActive) {
            setIsActive(true);
            return;
          }
          setIsActive(false);
        }}
        disabled={btnStatus && true}
        data-tip
        data-for={tooltipFor ?? null}
      >
        {SliderIcon ? SliderIcon : <DefaultSliderIcon />}
      </button>
      <div
        key={`${Math.round(sliderValue)}_op`}
        ref={sliderContainerRef}
        className={`${
          !isActive ? `hidden` : `block`
        } absolute left-0 slide-up mt-10 p-2 rounded-lg shadow-lg border-2 bg-gray-300 border-blue-600 z-10 group-hover:block range-container
        `}
      >
        <input
          ref={opacitySliderRef}
          type="range"
          orient="vertical"
          aria-label="opacity slider"
          defaultValue={sliderValue === undefined ? 1 : sliderValue}
          min="0"
          max="1"
          step="0.1"
          className="input-vertical-range"
          onMouseUp={onRangerChange}
        />
      </div>
    </div>
  );
};

export { OpacitySlider, useOpacity };
